import { render, staticRenderFns } from "./Skillcheck.vue?vue&type=template&id=01d55166&scoped=true"
import script from "./Skillcheck.vue?vue&type=script&lang=js"
export * from "./Skillcheck.vue?vue&type=script&lang=js"
import style0 from "./Skillcheck.vue?vue&type=style&index=0&id=01d55166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d55166",
  null
  
)

export default component.exports